import React from "react";
import { motion } from "framer-motion";
import greenBg from "../../assets/layer-bg-green2.png";

export const ScheduleSection: React.FC = () => {
  const timeline = [
    { date: "24 Mart 2026", label: "Başvuru Sürecinin Başlaması" },
    { date: "8 Nisan 2026", label: "Son Başvuru Tarihi", badge: "SON TARİH" },
    { date: "11 Nisan 2026", label: "Büyük Final ve Ödül Töreni", badge: "FİNAL GÜNÜ" },
  ];
  const finalDayFlow = [
    { time: "10.00 - 10.30", activity: "Kayıt, Karşılama ve Açılış Konuşmaları" },
    { time: "10.30 - 12.30", activity: "Jüri Sunumları (1. Oturum)" },
    { time: "12.30 - 13.30", activity: "Öğle Yemeği ve Networking" },
    { time: "13.30 - 14.30", activity: "Jüri Sunumları (2. Oturum)" },
    { time: "14.30 - 15.15", activity: "Jüri Değerlendirmesi ve Serbest Zaman" },
    { time: "15.15 - 16.00", activity: "Sonuçların Açıklanması, Ödül Töreni ve Kapanış" },
  ];

  return (
    <section id="timeline" className="section-shell bg-[var(--bg-secondary)] relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 text-center">
          <h2 className="text-4xl sm:text-5xl font-black text-[var(--text-primary)] mb-4">
            Etkinlik Süreci
          </h2>
          <div className="w-24 h-1 mx-auto rounded-full bg-[#73E03A]" />
        </div>
        <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3 gap-2 sm:gap-4">
          {timeline.map((item, idx) => (
            <motion.div
              key={item.date}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.06 }}
              className="relative"
            >
              <div className="kapsul-card kapsul-hover-lift p-2 sm:p-4 h-full relative pb-9 sm:pb-4">
                <p className="text-[10px] sm:text-xs md:text-sm font-semibold text-[#3F9A1D]">{item.date}</p>
                <p className="text-[10px] sm:text-xs md:text-sm font-semibold text-[var(--text-primary)] mt-1">{item.label}</p>
                {item.badge && (
                  <span
                    className="inline-flex px-3 py-1 text-xs font-semibold kapsul-badge border absolute left-2 bottom-2 sm:static sm:mt-2"
                    style={{
                      color: "#245314",
                      borderColor: "rgba(115,224,58,0.4)",
                      backgroundColor: "rgba(115,224,58,0.15)",
                    }}
                  >
                    {item.badge}
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>

        <div
          className="mt-8 rounded-2xl border p-4 sm:p-6"
          style={{
            borderColor: "rgba(115,224,58,0.45)",
            background: "linear-gradient(145deg, rgba(32,58,28,0.95), rgba(24,45,20,0.95))",
          }}
        >
          <div className="flex items-center justify-between gap-3 mb-4">
            <h3 className="text-xl font-bold text-white">Final Günü Akışı</h3>
            <span className="kapsul-badge px-3 py-1 text-[11px] font-semibold text-[#14300A] bg-[#A9E45F]">
              11 NİSAN 2026
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2 sm:gap-3">
            {finalDayFlow.map((item) => (
              <div
                key={item.time}
                className="rounded-lg sm:rounded-xl border px-2.5 sm:px-4 py-2.5 sm:py-3 kapsul-hover-lift"
                style={{ borderColor: "rgba(172,238,127,0.32)", backgroundColor: "rgba(255,255,255,0.06)" }}
              >
                <p className="text-xs sm:text-base font-bold text-[#C8F56B] leading-tight">{item.time}</p>
                <p className="mt-1 text-[11px] sm:text-sm text-white/90 leading-snug">{item.activity}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
